import React, { useState } from 'react'
import { Button, Divider } from 'antd'
import { useTranslation } from 'react-i18next'
import { NodeContentProps } from '../../types'
import DimensionTreeSelect from '../../../../../../../../features/dimension/components/DimensionTreeSelect'
import { useCalculatedReport } from '../../../../CalculatedReportContext'

const DimensionNodeContent: React.FC<NodeContentProps> = ({ node, context, onUpdateValue }) => {
  const { t } = useTranslation()
  const [open, setOpen] = useState(false)
  const { data: reportData } = useCalculatedReport()
  const arg = reportData?.args?.find(a => a.type === 'dimension')

  // Handler for selecting an argument instead of a dimension
  const handleSelectArgument = () => {
    if (!arg?.id) return
    setOpen(false)
    // Set the node to use an argument instead of a dimension
    onUpdateValue(node.id, { value: undefined, argumentId: arg.id })
  }

  // Check if this option is currently selected
  const isUsingArgument = Boolean(node.argumentId)

  // Display value logic - when using argument, show empty string to avoid dimension showing
  let displayValue = ''
  if (isUsingArgument) {
    displayValue = t('global:dynamic')
  } else {
    displayValue = node.value ? String(node.value) : ''
  }

  return (
    <DimensionTreeSelect
      companyId={context.company}
      style={{ width: 200 }}
      value={displayValue}
      onChange={value => onUpdateValue(node.id, { value, argumentId: null })}
      open={open}
      onOpenChange={setOpen}
      data-cy={`dimension-select-${node.id}`}
      popupRender={menu => (
        <div>
          {menu}
          <Divider />
          <Button
            color={isUsingArgument ? 'primary' : 'default'}
            variant={isUsingArgument ? 'filled' : 'outlined'}
            block
            disabled={!arg?.id}
            onClick={handleSelectArgument}
            data-cy={`select-argument-${node.id}`}
          >
            {t('global:dynamic')}
          </Button>
        </div>
      )}
    />
  )
}

export default DimensionNodeContent
